/* global femcare, Swiper */

femcare.gallery.retailers = {

    init: function () {
        if ($('.product-retailers').length) {
            this.initSliders();
        }
        if ($('.product-main').length) {
            this.initAnalytics();
        }
    },

    initSliders: function () {
        var $retailers = $('.product-retailers');

        if ($retailers.length) {

            var options = {
                lazy: true,
                breakpoints: {
                    350: {
                        slidesPerView: 3.5
                    },
                    500: {
                        slidesPerView: 4
                    },
                    600: {
                        slidesPerView: 5
                    },
                    1200: {
                        slidesPerView: 6
                    }

                },
                navigation: {
                    nextEl: '.product-retailers__next',
                    prevEl: '.product-retailers__previous'
                },
            };

            $retailers.each(function () {
                var instanceOptions = JSON.parse(JSON.stringify(options));
                new Swiper('.product-retailers__slider', instanceOptions);
            });
        }
    },

    initAnalytics: function () {
        var productName = $('.product-main__name').text();
        var pageUrl = window.location.href.split('#')[0];

        $('.product-buy .product-buy__actions a, .product-buy .product-buy__actions button').on('click', function () {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'buyNowClick',
                    eventCategory: 'Buy Now - List Retailers',
                    eventAction: productName,
                    eventLabel: pageUrl,
                    eventValue: undefined
                });
            }
        });

        $('.product-retailers__slide a').on('click', function () {
            var retailerUrl = $(this).attr('href');
            var regex = new RegExp('^(?:https?://)?(?:[^@/n]+@)?(?:www.)?([^:/?n]+)'),
                retailerDomain = regex.exec(retailerUrl);

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'buyNowClick',
                    eventCategory: 'Buy Now - Retailer Click - Retailer Domain',
                    eventAction: productName,
                    eventLabel: retailerDomain[0],
                    eventValue: undefined
                });
            }

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'buyNowClick',
                    eventCategory: 'Buy Now - Retailer Click - Page URL',
                    eventAction: productName,
                    eventLabel: pageUrl,
                    eventValue: undefined
                });
            }
        });
    }
};